import * as React from 'react'
import { ISettingItem } from '../../types/global-settings'
import SettingListItem from './SettingListItem'

interface ISettingListProps {
  settings: ISettingItem[]
  baseUrl: string
}

const SettingList = (props: ISettingListProps) => (
  <div>
    {props.settings.map(setting => (
      <SettingListItem baseUrl={props.baseUrl} key={`setting_list_item_${setting.id}`} {...setting} />
    ))}
  </div>
)

export default SettingList



// WEBPACK FOOTER //
// ./src/components/global-settings/SettingList.tsx